// extracted by mini-css-extract-plugin
export default {"nav-links":"NavLinks_nav-links__LH6vz","small":"NavLinks_small__bASCP"};